export default __webpack_public_path__ + "static/project-slide-8-4032-2268-9b4a34c247942e245cf86df9f6ecd1d2.jpg";